import React, { memo, useRef } from "react";
import { Stack, Typography } from "@mui/material";
import { CheckboxInput, SearchInput } from "components/Form";
import { CustomTooltip, DynamicAvatar } from "Reuse/UI";

const Dropdown = (props) => {
  const {
    data,
    paginationUI = null,
    isSearch = false,
    selected,
    toogleEvent,
  } = props;
  const scrollRef = useRef(null);

  return (
    <Stack
      ref={scrollRef}
      sx={{ flexDirection: "column", gap: 0.5,
        overflowY: "scroll",
        // padding: 1,
        // width: 502,
      }}
    >
      {isSearch ? <SearchInput /> : null}
      {data.map((row) => {
        return (
          <Option
            key={row.id}
            {...row}
            selected={selected}
            toogleEvent={toogleEvent}
          />
        );
      })}
      {paginationUI}
    </Stack>
  );
};

export default memo(Dropdown);

const Option = memo(
  ({
    selected,
    toogleEvent,
    disabled = false,
    disabledText = "",
    ...props
  }) => {
    const { name, logo_url, id } = props;
    const checked = selected.some((item) => item.id === id);

    return (
      <CustomTooltip title={disabled ? disabledText : ""}>
        <Stack
          // component={Paper}
          // elevation={0}
          sx={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", p: 1, minHeight: 32, background: "#F4F4F5" }}
        >
          <Stack sx={{ flexGrow: 1, flexDirection: "row", alignItems: "center", gap: 1 }}>
            <DynamicAvatar
              alt={name}
              src={logo_url}
              sx={{ width: 24, height: 24, mr: 1.5 }}
            />
            <Typography
              id={`option-${id}`}
              variant="body1"
              sx={{
                fontWeight: 500,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              {name}
            </Typography>
          </Stack>
          <CheckboxInput
            color="primary"
            checked={checked}
            onChange={(e) => toogleEvent(e, props)}
            // named by the option's text ("Shelbyville ISD")
            inputProps={{ "aria-labelledby": `option-${id}` }}
            disabled={disabled}
          />
        </Stack>
      </CustomTooltip>
    );
  }
);
